import { render, staticRenderFns } from "./hahaha.vue?vue&type=template&id=81895db0&scoped=true"
import script from "./hahaha.vue?vue&type=script&lang=js"
export * from "./hahaha.vue?vue&type=script&lang=js"
import style0 from "./hahaha.vue?vue&type=style&index=0&id=81895db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81895db0",
  null
  
)

export default component.exports